import React from 'react';

import { useTranslation } from 'react-i18next';

/**
 * Well-Architected Workload Icon
 */
export const WellArchitectedWorkloadIcon = (
  props?: React.ComponentProps<'svg'>,
) => {
  const { t } = useTranslation('containerInterface');
  return (
    <svg viewBox="0 0 40 40" {...props}>
      <title>{t('awsWellArchitectToolWorkload')}</title>
      <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
        <path
          d="M27.8253012,20 L24.4331325,14.0909091 C24.2722892,13.8090909 23.9740964,13.6363636 23.6506024,13.6363636 L16.3475904,13.6363636 C16.0259036,13.6363636 15.7277108,13.8090909 15.5668675,14.0909091 L12.1746988,20 L8,20 L13.739759,10 L26.260241,10 L32,20 L27.8253012,20 Z M26.9640777,30 L25,26.4939618 L28.0752427,21 L32,21 L26.9640777,30 Z M20.0994547,31 L18,27 L22.9005453,27 L25,31 L20.0994547,31 Z M14,20.95 L16.9765557,16 L22.9904486,16 L26,21 L22.9904486,26 L17.0390738,26 L14,20.95 Z M13.7525811,32 L8,22 L12.1840246,22 L15.5837711,27.9090909 C15.6362978,28.0036364 15.7069371,28.0854545 15.7866329,28.1527273 L18,32 L13.7525811,32 Z M33.881958,20.0535714 L27.3188227,8.44642857 C27.1649309,8.16964286 26.8763838,8 26.5633539,8 L13.4370833,8 C13.1240534,8 12.8355063,8.16964286 12.6798657,8.44642857 L6.11673042,20.0535714 C5.96108986,20.3303571 5.96108986,20.6696429 6.11673042,20.9464286 L12.6798657,32.5535714 C12.8355063,32.8303571 13.1240534,33 13.4370833,33 L26.5633539,33 C26.8763838,33 27.1649309,32.8303571 27.3188227,32.5535714 L33.881958,20.9464286 C34.0393473,20.6696429 34.0393473,20.3303571 33.881958,20.0535714 L33.881958,20.0535714 Z"
          fill="currentColor"
        ></path>
      </g>
    </svg>
  );
};
